<script>

import debounce from "buefy/src/utils/debounce.js";

export default {
    props: ['user'],
    data() {
        return {
            errors: {},
            loading: false,
            loadingCompanies: false,
            companies: [],
            controller: {
                submit: null,
                load: null
            },
            selectedCompany: null,
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.controller.submit = new AbortController();
            let request;
            let data = {
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                phone_number: this.user.phone_number,
                pesel: this.user.pesel,
                company_id: this.user.company_id
            }
            if (this.user.id) {
                request = axios.put('/users/trainers/' + this.user.id, data, {
                    signal: this.controller.submit.signal
                })
            } else {
                request = axios.post('/users/trainers', data, {
                    signal: this.controller.submit.signal
                })
            }
            request.then((response) => {
                if (this.user.id) {
                    this.$toast.success(this.$t('trainers.messages.account_updated'));
                } else {
                    this.$toast.success(this.$t('trainers.messages.account_updated'));
                }
                this.$router.push({name: 'trainers.index'});
            }).catch((data) => {
                this.errors = data.response?.data?.errors || {};
            }).finally(() => {
                this.loading = false;
            })
        },
        loadCompanies() {
            if (this.controller.load) {
                this.controller.load.abort();
            }
            this.controller.load = new AbortController();
            this.loadingCompanies = true;
            axios.get('/companies',{
                signal: this.controller.load.signal
            }).then(response => {
                this.companies = response.data.data;
            }).catch(error => {
            }).finally(() => {
                this.loadingCompanies = false;
            })
        }

    },
    mounted() {
        this.loadCompanies();
    },
    beforeUnmount() {
        if (this.controller.submit) {
            this.controller.submit.abort();
        }
        if (this.controller.load) {
            this.controller.load.abort();
        }
    }
}

</script>
<template>
    <div class="trainings-create">

        <form @submit.prevent="submit">

            <section class="block">

                <b-field :label="$t('users.fields.first_name.name')" custom-class="mb-3"
                         :type="errors.first_name ? 'is-danger' : null"
                         :message="errors.first_name ? errors.first_name[0] : null">
                    <b-input required
                             v-model="user.first_name"
                             icon="account"
                    ></b-input>
                </b-field>

                <b-field :label="$t('users.fields.last_name.name')" custom-class="mb-3"
                         :type="errors.last_name ? 'is-danger' : null"
                         :message="errors.last_name ? errors.last_name[0] : null">
                    <b-input required
                             v-model="user.last_name"
                             icon="account"
                    ></b-input>
                </b-field>

                <b-field :label="$t('users.fields.email.name')" custom-class="mb-3"
                         :type="errors.email ? 'is-danger' : null"
                         :message="errors.email ? errors.email[0] : null">
                    <b-input required
                             type="email"
                             v-model="user.email"
                             icon="at"
                    ></b-input>
                </b-field>

                <b-field :label="$t('users.fields.phone_number.name')" custom-class="mb-3"
                         :type="errors.phone_number ? 'is-danger' : null"
                         :message="errors.phone_number ? errors.phone_number[0] : null">
                    <b-input v-model="user.phone_number" icon="phone"
                    ></b-input>
                </b-field>

                <b-field :label="$t('users.fields.pesel.name')" custom-class="mb-3"
                         :type="errors.pesel ? 'is-danger' : null"
                         :message="errors.pesel ? errors.pesel[0] : null">
                    <b-input
                        maxlength="11"
                        v-model="user.pesel"
                        icon="card-account-details-outline"
                    ></b-input>
                </b-field>

                <b-field :label="$t('users.fields.company.name')"
                         custom-class="mb-3"
                         :type="errors.company_id ? 'is-danger' : null"
                         label-for="company"
                         :message="errors.company_id ? errors.company_id[0] : null">

                    <b-select :placeholder="$t('users.fields.company.placeholder')" expanded v-model="user.company_id"
                              id="company" icon="domain" :loading="loadingCompanies">
                        <option v-bind:value="company.id" v-for="company in companies" :key="company.id">
                            {{ company.name }}
                        </option>
                    </b-select>

                </b-field>

            </section>

            <section class="buttons">
                <b-button type="is-primary" native-type="submit" :loading="loading">
                    {{ $t('actions.save') }}
                </b-button>
                <b-button @click.prevent="$router.push({name: 'trainers.index'})">
                    {{ $t('actions.back') }}
                </b-button>
            </section>

        </form>
    </div>
</template>
